export const reCaptchaSiteKey = document.getElementById('reCaptchaSiteKey').value

/**
 * @todo kiểm tra định dạng email
 * @param {*} email 
 * @return true | false
 */
export function isValidEmail(email) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

export function postToServer(url,bodyObject) {
  return new Promise((resolve,reject)=>fetch(url, {
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    credentials: 'same-origin',
    body: JSON.stringify(bodyObject)
  }).then(response => {
    if(response.status===419) {
      alert('Your session is already expired because you are idle for too long. Page will automatic refesh.');
      window.location.reload();
    }
    if(response.ok) {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) response.json().then(json=>resolve(json))
      else response.text().then(text=>resolve(text));
    }
    else response.text().then(text =>reject({status:response.status,text}))
  }).catch(err=>reject(err)))
}